<div class="emd-container eu-display_flex eu-column no-border">
    <div #pdf_element class="emd-container">
        <div class="emd-container__header title">
            <h2 class="emd-text _size_page _align_center w-100">{{ title }}</h2>
        </div>
        <div class="emd-container__content">
            <div class="table-responsive eu-display_flex eu-justify_center">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
    <div class="emd-container">
        <div *ngIf="exportable" class="emd-container__footer eu-justify_end">
            <button
                type="button"
                class="emd-btn _color_primary"
                (click)="exportAsPDF()"
                [disabled]="exportIsLoading"
            >
                Exportar
                <app-dot-loading
                    *ngIf="exportIsLoading"
                    [isLoading]="exportIsLoading"
                ></app-dot-loading>
            </button>
        </div>
    </div>
</div>
